import { TableColumn } from '../consts';
import { SortArrowIcon } from 'assets/svg';

type Props = {
  columns: TableColumn[];
  sortBy: string;
  sortDir: string;
  onSort: (columnKey: string) => void;
};

function SortControls({ columns, sortBy, sortDir, onSort }: Props) {
  const sortableColumns = columns.filter((column) => column.sortable);

  if (sortableColumns.length === 0) {
    return null;
  }

  return (
    <div className="flex items-center gap-2 px-4 py-3">
      <label htmlFor="orders-sort-by" className="font-klarheit text-sm text-palette-secondary-grey">
        Sort by
      </label>
      <select
        id="orders-sort-by"
        value={sortBy}
        onChange={(event) => onSort(event.target.value)}
        className="min-w-0 grow rounded border border-palette-color-bg-grey bg-white px-2 py-1 text-base"
      >
        {sortableColumns.map((column) => (
          <option key={column.key} value={column.key}>
            {column.headerLabel}
          </option>
        ))}
      </select>
      <button
        type="button"
        onClick={() => onSort(sortBy)}
        aria-label={
          sortDir === 'ASC' ? 'Sorted ascending, switch to descending' : 'Sorted descending, switch to ascending'
        }
        className="shrink-0 rounded p-2 hover:text-palette-secondary-dark focus-visible:outline focus-visible:outline-2 focus-visible:outline-palette-secondary"
      >
        <SortArrowIcon className={`w-3 h-3 ${sortDir === 'ASC' ? 'rotate-180' : ''}`} />
      </button>
    </div>
  );
}

export default SortControls;
